import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import * as icons from '@material-ui/icons';

import { SubmitButton } from 'src/components';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 24,
  },
  right: {
    marginLeft: 'auto',
  },
}));

interface HeaderProps {
  onExport?: () => void;
  isExporting?: boolean;
  exportDataLoading?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  onExport,
  isExporting,
  exportDataLoading = false,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      justify="space-between"
      alignItems="center"
      direction="row"
      spacing={2}
      className={classes.root}
    >
      <Grid item>
        <Typography variant="h4">Portfolio Overview</Typography>
      </Grid>
      <Grid item className={classes.right}>
        <SubmitButton
          onClick={onExport}
          color="secondary"
          variant="outlined"
          size="large"
          startIcon={<icons.GetApp />}
          disabled={exportDataLoading}
          loading={isExporting}
        >
          Export
        </SubmitButton>
      </Grid>
    </Grid>
  );
};
